// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__4qWTI","topBottomGutter":"Layout_topBottomGutter__3XNy-"};